require('./bootstrap');

require('owl.carousel/dist/owl.carousel');
require('bootstrap-notify/bootstrap-notify');
require('inputmask/dist/jquery.inputmask.min');
require('readmore-js');
import VueLazyLoad from 'vue-lazyload'
require('./script');
require('./components/mainFilterToggle');
require('./components/jquery-gallery');
import Notifications from 'vue-notification';
import Vue from 'vue';
Vue.use(VueLazyLoad);
Vue.use(Notifications);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import lang from 'element-ui/lib/locale/lang/ru-RU'
import locale from 'element-ui/lib/locale'
locale.use(lang);
Vue.component('main-filters', require('./components/mainFilters').default);
Vue.component('flat-filters',require('./components/flats/flatsFilters').default);
Vue.component('building-gallery', require('./components/gallery').default);
Vue.component('flat-gallery', require('./components/flats/FlatGallery').default);
Vue.component('comment-actions-m', require('./components/comment/components/comments-actions-m').default);
Vue.component('comment-actions-d',require('./components/comment/components/comment-actions-d').default);
Vue.component('comment-modal', require('./components/comment/modal').default);
Vue.component('comments', require('./components/comment/index').default);
Vue.component('favorite-button',require('./components/favorite/FavoriteButton').default);
Vue.component('favorite-counter',require('./components/favorite/FavoriteCounter').default);
Vue.component('favorite',require('./components/favorite/favorite').default);
Vue.component('buildings-map',require('./components/building/map-list/index').default);
Vue.component('ShowOnMap',require('./components/building/ShowOnMap').default);
Vue.component('ShowOnMapFlat',require('./components/flats/ShowOnMapFlat').default);
Vue.component('ShowOnMapVillage',require('./components/cottage/ShowOnMapVillage').default);
Vue.component('Apartments',require('./components/building/apartment/index').default);
Vue.component('CottageApartments',require('./components/cottage/apartment/index').default);
Vue.component('BuildingReports', require('./components/building/reports/index').default);
Vue.component('CottageReports', require('./components/cottage/reports/index').default);
Vue.component('BuildingScrollNav', require('./components/building/scroll-nav').default);
Vue.component('CottageScrollNav', require('./components/cottage/scroll-nav').default);
Vue.component('ReviewShowOnMap',require('./components/reviews/ShowOnMap').default);
Vue.component('flats-map',require('./components/flats/map-list/index').default);
Vue.component('SearchApartments', require('./components/search-apartment/index').default);
Vue.component('ApartmentsToggleList',require('./components/search-apartment/toggleList').default);
Vue.component('CallbackForm', require('./components/callback/form').default);
Vue.component('FlatConsultationForm', require('./components/flats/consultation/form').default);
Vue.component('BuildingConsultationForm',require('./components/building/consultation/form').default);
Vue.component('SpecialCallbackForm', require('./components/special/callback/form').default);
Vue.component('SelectBuildingQuestionForm',require('./components/select-building/callback/question-form').default);
Vue.component('SelectBuildingConsultationForm', require('./components/select-building/callback/consultation').default);
Vue.component('ContestReview', require('./components/contest-review/index').default);
Vue.component('AboutContactForm', require('./components/about-page/contact-form').default);
Vue.component('CottageFilter', require('./components/cottage/CottageFilter').default);
Vue.component('CottageMap',require('./components/cottage/map-list/index').default);
Vue.directive('phone', {
    bind(el) {
        el.oninput = function(e) {
            if (!e.isTrusted) {
                return
            }
            if (this.value[0] === '8') {
                this.value = this.value.replace('8', '+7');
            }
            if (this.value.replace(/[^0-9]+/g, '') === '789') {
                this.value = '79';
            }
            const x = this.value.replace(/\D/g, '').match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);
            x[1] = '+7';
            this.value = !x[3] ? x[1] + ' (' + x[2] : x[1] + ' (' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '') + (x[5] ? '-' + x[5] : '')

        }

    }
})
import StarRating from 'vue-star-rating';
export const eventBus = new Vue();
const app = new Vue({
    el: '#app',
    components: {
        StarRating
    },
    data: {
        isLoading: true,
        filtered:false,
    },
    computed: {
        signedIn() {
            return window.App.signedIn;
        },
        user(){
            return  window.App.user;
        },
    },
    created(){
        this.loadedApp();
    },
    methods: {
        async loadedApp(){
            this.isLoading = false;
        },
        likeOrDislike(type) {
            this.filtered = true;
            eventBus.$emit('like-or-dislike', type);
        },
        answerComment(id) {
            this.filtered = true;
            eventBus.$emit('answer-comment', id);
        }
    }
});
